
export interface HoursPart {
  id: string;
  estimate: number | null;
  spent: number;
  done: boolean;
}

export interface HoursSegment {
  id: string;
  width: number;
  filled: number;
  done: boolean;
  overrun: boolean;
}

export interface HoursLayout {
  total: number;
  spent: number;
  plan: number | null;
  over: number;
  uncut: number;
  planAt: number | null;
  segments: HoursSegment[];
  withoutEstimate: number;
}

export function layoutHours(plan: number | null, parts: HoursPart[]): HoursLayout {
  const estimated = parts.filter((p) => p.estimate != null && p.estimate > 0);
  const total = estimated.reduce((sum, p) => sum + (p.estimate ?? 0), 0);
  const spent = parts.reduce((sum, p) => sum + p.spent, 0);
  const planned = plan != null && plan > 0 ? plan : null;
  const scale = Math.max(planned ?? 0, total);
  const segments: HoursSegment[] =
    scale > 0
      ? estimated.map((p) => {
          const estimate = p.estimate ?? 0;
          return {
            id: p.id,
            width: estimate / scale,
            filled: p.done ? 1 : Math.min(1, p.spent / estimate),
            done: p.done,
            overrun: p.spent > estimate,
          };
        })
      : [];
  return {
    total,
    spent,
    plan: planned,
    over: planned != null ? Math.max(0, total - planned) : 0,
    uncut: planned != null ? Math.max(0, planned - total) : 0,
    planAt: planned != null && scale > 0 ? planned / scale : null,
    segments,
    withoutEstimate: parts.length - estimated.length,
  };
}
